import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { CATEGORIES } from "../lib/tools";

export default function ToolCard({ tool, featured, index = 0 }) {
  const Icon = tool.icon;
  const cat = CATEGORIES.find((c) => c.id === tool.cat);
  return (
    <Link
      to={`/tool/${tool.slug}`}
      data-testid={`tool-card-${tool.slug}`}
      className={`tool-card animate-fade-up ${featured ? "md:col-span-2" : ""}`}
      style={{ animationDelay: `${Math.min(index, 12) * 30}ms` }}
    >
      <div className="flex items-start justify-between">
        <div className="h-10 w-10 rounded-lg flex items-center justify-center"
          style={{ background: `${cat?.accent}14`, color: cat?.accent }}>
          <Icon size={20} strokeWidth={1.75} />
        </div>
        <span className="text-[10px] uppercase tracking-[0.18em] font-semibold text-gray-400">
          {cat?.label}
        </span>
      </div>
      <h3 className="font-heading text-lg font-semibold mt-5 flex items-center gap-2">
        {tool.name}
        <ArrowRight className="arrow" size={16} strokeWidth={2} />
      </h3>
      <p className="text-sm text-gray-500 mt-1.5 leading-relaxed">{tool.desc}</p>
    </Link>
  );
}
